export const createStyles = (theme?: any) => ({
  gotItModalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    p: '1.5rem 1rem',
    height: '342px',
    width: '343px',
    background: theme?.palette?.background?.paper,
    borderRadius: '0.5rem',
    gap: '1rem',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
    alignItems: 'center',
  },
  gotItTitle: {
    fontSize: '1.25rem',
    fontWeight: 500,
    lineheight: '160%',
    letterSpacing: '0.15px',
    color: theme?.palette?.text?.primary,
    mt: '0.25rem',
  },
  gotItButton: {
    width: '100%',
    height: '42px',
    maxHeight: '42px',
    fontSize: '0.9375rem',
    fontWeight: 500,
    lineHeight: '26px',
    letterSpaceing: '0px',
    mt: '0.5rem',
  },
  avatar: {
    width: '38px',
    height: '38px',
  },
  paragraph: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: '0.15px',
    color: theme?.palette?.text?.primary,
  },
});
